import Contract, {ContractDTO, ReceiptItem, CheckPointItem} from "@/model/contract";
import api from "./api";
import PaginateModel, { PaginateDTO } from "@/model/paginate";
import ContractHistory from "@/model/contractHistory";

interface ContractListResponseInterface {
  meta: string;
  data: {
    data: ContractDTO[];
    pagination: any;
  };
}

interface ContractList {
  paginate: PaginateDTO;
  list: Contract[];
}

interface ContractCheckPointList {
  list: CheckPointItem[];
}

class ContractApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async index(query): Promise<ContractList> {
    const response = await this.getHttp().get<ContractListResponseInterface>(
      "/contracts",
      {
        params: query,
      }
    );

    const list = response.data.data.data.map((item) => {
      return new Contract(item);
    });

    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list,
      paginate,
    };
  }

  async getContracts(query = {}, data = {}): Promise<Contract[]> {
    const response = await this.getHttp().get<any>("/contracts/without-paginate", {
      data: data,
      params: query,
    });
    if (response.status === 200) {
      return response.data.data.map((item) => new Contract(item));
    }
  }

  async detail(id): Promise<Contract> {
    const response = await this.getHttp().get<any>(
      "/contracts/" + id
    );

    if (response.status === 200) {
      return new Contract(response.data.data);
    }
  }

  async store(contract: Contract) {
    const response = await this.getHttp().post<any>("/contracts", contract);
    return response.data;
  }

  async update(contract: Contract) {
    const response = await this.getHttp().put<any>("/contracts/" + contract.id, contract);
    return response.data;
  }

  async remove(id: string) {
    const response = await this.getHttp().delete<any>("/contracts/" + id);
    return response.data;
  }

  async history(contractId: string): Promise<ContractHistory[]> {
    const response = await this.getHttp().get<any>("/contracts/" + contractId + "/histories");

    if (response.status === 200) {
      return response.data.data.map(item => new ContractHistory(item));
    }
  }

  async acception(contractId: string, type): Promise<ContractHistory[]> {
    const response = await this.getHttp().put<any>("/contracts/" + contractId + "/acception", {
      'is_confirmed': type
    });
    return response.data;
  }

  async receipt_confirmation(id): Promise<ReceiptItem> {
    const response = await this.getHttp().get<any>(
      "/contracts/" + id + "/receipt-confirmation/"
    );

    if (response.status === 200) {
      return response.data.data.map(item => new ReceiptItem(item));
    }
  }

  async getConfirmCheckPointListByContract(id): Promise<ContractCheckPointList> {
    const response = await this.getHttp().get<any>(
      "/customers/contracts/" + id + "/confirm-check-list"
    );

    if (response.status === 200) {
      const list = response.data.data.data.map((item) => {
        return new CheckPointItem(item)
      });

      return {
        list,
      }
    }
  }
}
export default new ContractApi();
